import { EcpLocatorRequestUrls } from './ecp-locator.request-urls';

const ecpLocatorPaths = Object.values(EcpLocatorRequestUrls) as string[];

export const isEcpLocatorUrl = (url: string | undefined): boolean =>
  !!(url && ecpLocatorPaths.some((path) => url.includes(path)));

